import { useCallback } from 'react'

import { useNotification } from '@/hooks'
import { copyToClipboard } from '@/utils'

import { useTexts } from './useTexts'
import { useApiKey } from '../../hooks/useApiKey'

export function useActions() {
  const texts = useTexts()
  const { apiKey } = useApiKey()
  const toast = useNotification()

  const onCopyApiKey = useCallback(async () => {
    if (!apiKey) return

    const copied = await copyToClipboard(apiKey)
    copied
      ? toast.success(texts.copyApiKeySuccess, { autoClose: 5000 })
      : toast.error(texts.copyApiKeyError, { autoClose: 5000 })
  }, [toast, texts, apiKey])

  return {
    onCopyApiKey,
  }
}
